<template>
  <div style="width: 100%; height: 90%">
    <ag-grid-vue
      style="width: 100%; height: 90%"
      class="ag-theme-alpine"
      id="myGrid"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      :headerHeight="48"
      :rowSelection="rowSelection"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @row-selected="onRowSelected"
      :rowData="rowData"
    >
    </ag-grid-vue>
    <v-btn color="green darken-1" v-on:click="addItems()">Add Row</v-btn>
    <v-btn color="red darken-1" v-on:click="onRemoveSelected()"
      >Remove Selected</v-btn
    >
    <v-btn color="blue darken-1" @click="save">Save</v-btn>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import axios from "axios";
import { AutocompleteSelectCellEditor } from "ag-grid-autocomplete-editor";
import "ag-grid-autocomplete-editor/main.css";
import {
  mapState,
  mapGetter,
  mapActions
} from 'vuex'
export default {
  name: "train_dtls",
  data() {
    return {
      gridOptions: null,
      gridApi: null,
      rowSelection: null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,
      rowData: null,
      editedRowIDs: new Set([]),
      editedRows: [],
    };
  },
  components: {
    AgGridVue,
  },
  beforeMount() {
    this.gridOptions = {};
    this.rowSelection = "single";
    this.columnDefs = [
      // {headerName: 'pk', field: 'pk'},
      { headerName: "Sl No.", field: "stn_sr_no", sortable: true },
      { headerName: "train_no", field: "train_no" },
      { headerName: "stn_name", field: "stn_name", minWidth: 200 },
      { headerName: "stn_type", field: "stn_type" },
      {
        headerName: "stn_code",
        field: "stn_code",
        // cellEditor: AutocompleteSelectCellEditor,
        // cellEditorParams: {
        //     selectData: [
        //         { label: 'SDAH', value: 'SDAH' },
        //         { label: 'KGK', value: 'KGK' },
        //         { label: 'BNXR', value: 'BNXR' },
        //     ],
        //     placeholder: 'Select an option',
        //     autocomplete: {
        //       strict: false,
        //       autoselectfirst: false,
        //       required: false
        //     }
        // },
        // valueFormatter: (params) => {
        //     if (params.value) {
        //         return params.value.label || params.value.value || params.value;
        //     }
        //    // return "";
        // }
      },
      { headerName: "block_section", field: "block_section", minWidth: 120 },
      { headerName: "wtt_arr", field: "wtt_arr" },
      { headerName: "wtt_day_arr", field: "wtt_day_arr" },
      { headerName: "wtt_dep", field: "wtt_dep" },
      { headerName: "wtt_day_dep", field: "wtt_day_dep" },
      { headerName: "stop", field: "stop" },
      { headerName: "ptt_arr", field: "ptt_arr" },
      { headerName: "ptt_day_arr", field: "ptt_day_arr" },
      { headerName: "ptt_dep", field: "ptt_dep" },
      { headerName: "ptt_day_dep", field: "ptt_day_dep" },
      { headerName: "pf", field: "pf" },
      { headerName: "division", field: "division" },
      { headerName: "zone", field: "zone" },
      { headerName: "tr", field: "tr" },
      { headerName: "er", field: "er" },
      { headerName: "distance", field: "distance" },
    ];
    // this.columnDefs = [
    //       {
    //         headerName: "Sl No.",
    //         valueGetter: "node.rowIndex + 1", sortable: true, editable: false
    //       },
    //       {headerName: 'train_no', field: 'train_no', sortable: true, minWidth: 100,
    //       filter: 'agNumberColumnFilter',   filterParams: {
    //           resetButton: true,
    //           debounceMs: 200
    //       }},
    //       {headerName: 'train_name', field: 'train_name', sortable: true, minWidth: 150,
    //       filter: 'agTextColumnFilter'},
    //       {headerName: 'tr type', field: 'train_type', minWidth: 100, filter: 'agTextColumnFilter'},
    //       {headerName: 'dep', field: 'dep', sortable: true},
    //       {headerName: 'org', field: 'org', sortable: true, filter: 'agTextColumnFilter'},
    //       {headerName: 'dest', field: 'dest', sortable: true, filter: 'agTextColumnFilter'},
    //       {headerName: 'arr', field: 'arr', sortable: true},
    //       {headerName: 'days_of_run', field: 'days_of_run'},
    //       {headerName: 'valid_from', field: 'valid_from'},
    //       {headerName: 'valid_to', field: 'valid_to'},
    //       {headerName: 'zone', field: 'zone'},
    //       {headerName: 'divn', field: 'divn'},
    //       {headerName: 'depot', field: 'depot'},
    //       {headerName: 'travel_time', field: 'travel_time'},
    //       {headerName: 'total_kms ', field: 'total_kms '},
    //       {headerName: 'avg_speed ', field: 'avg_speed '},
    //       {headerName: 'er ', field: 'er '},
    //       {headerName: 'tr', field: 'tr'},
    //   ];

    this.rowData = [];
    this.defaultColDef = {
      flex: 1,
      minWidth: 88,
      editable: true,
      resizable: true,
      onCellValueChanged: this.onCellValueChanged,
    };
    this.getTrains();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;

  },
  computed: {
    ...mapState(['curUser']),
  },
  methods: {
    getTrains() {
      this.rowData = [];
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("jwtToken");
      axios
        .get(
          `${process.env.VUE_APP_API_URL}/timetable/train/${this.$route.query.train_no}`
        )
        .then((response) => {
          // console.log(response);
          this.rowData = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    onCellValueChanged(params) {
      // console.log(params)
      this.editedRowIDs.add(params.node.id);
    },
    save() {
      if (this.editedRowIDs.size == 0) {
        return;
      }
      // console.log(this.editedRows)
      this.editedRowIDs.forEach((id) => {
        this.editedRows.push(this.gridApi.getRowNode(id).data);
        // console.log(this.editedRows)
      });
      var p = {
        edited_trains: this.editedRows,
      };
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("jwtToken");

      axios
        .post(`${process.env.VUE_APP_API_URL}/timetable/train_dtls`, p)
        .then((response) => {
          // clear the set post update call
          this.editedRowIDs.clear();
          this.editedRows = [];
        })
        .catch((e) => {
          console.log(e);
        });
      // call the api to update data
    },
    onGridReady(params) {},
    populateGrid(workbook) {
      // our data is in the first sheet
      var firstSheetName = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[firstSheetName];

      // we expect the following columns to be present
      var columns = {
        A: "stn_sr_no",
        B: "train_no",
        C: "stn_name",
        D: "stn_type",
        E: "block_section",
        F: "wtt_arr",
        G: "wtt_day_arr",
        H: "wtt_dep",
        I: "wtt_day_dep",
        J: "stop",
        K: "ptt_arr",
        L: "ptt_day_arr",
        M: "ptt_dep",
        N: "ptt_day_dep",
        O: "pf",
        P: "division",
        Q: "zone",
        R: "tr",
        S: "er",
        T: "distance",
      };
      this.rowData = [];

      // start at the 2nd row - the first row are the headers
      var rowIndex = 2;

      // iterate over the worksheet pulling out the columns we're expecting
      while (worksheet["A" + rowIndex]) {
        var row = {};
        Object.keys(columns).forEach(function (column) {
          row[columns[column]] = worksheet[column + rowIndex].w;
        });

        this.rowData.push(row);

        rowIndex++;
      }

      // finally, set the imported rowData into the grid

      //  gridOptions.api.setRowData(rowData);
    },
    onRowSelected(event) {
      // console.log(event)
    },
    addItems(addIndex) {
      var newItems = [
        {
          stn_sr_no: 0,
          train_no: this.$route.query.train_no,
          stn_name: null,
          stn_type: null,
          block_section: null,
          wtt_arr: null,
          wtt_day_arr: null,
          wtt_dep: null,
          wtt_day_dep: null,
          stop: null,
          ptt_arr: null,
          ptt_day_arr: null,
          ptt_dep: null,
          ptt_day_dep: null,
          pf: null,
          division: this.$store.state.curUser.division,
          zone: this.$store.state.curUser.zone,
          tr: null,
          er: null,
          distance: null,
        },
      ];
      var selectedData = this.gridApi.getSelectedRows();
      // console.log(selectedData)
      var res = this.gridApi.applyTransaction({
        add: newItems,
        addIndex: addIndex,
      });
    },
    onRemoveSelected() {
      var selectedData = this.gridApi.getSelectedRows();
      if (selectedData.length == 0) {
        return;
      }
      var p = {
        train_no: selectedData[0].train_no,
        stn_sr_no: selectedData[0].stn_sr_no,
      };
      if (confirm("Are you sure you want to delete this item?")) {
        axios.defaults.headers.common["Authorization"] =
          localStorage.getItem("jwtToken");
        axios
          .delete(
            `${process.env.VUE_APP_API_URL}/timetable/delete_train_from_tt`,
            { params: p }
          )
          .then((response) => {
            //alert("Registered successfully")
            this.gridApi.applyTransaction({ remove: selectedData });
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
  },
};
</script>
<style lang="scss">
@import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";
.ag-header-cell-label {
  text-overflow: clip;
  overflow: visible;
  white-space: normal;
}
</style>
